import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { GridStore } from '../stores/grid/grid.state';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';

/**
 * Guard that prevents the user from navigating away from a route or to a sibling route
 * if there are unsaved changes in the GridStore. It shows a confirmation dialog
 * if changes are detected.
 *
 * @return {CanActivateFn | CanDeactivateFn<any>} The functional guard.
 */
export const unsavedChangesGuard:
  | CanActivateFn
  | CanDeactivateFn<any> = async () => {
  const gridStore = inject(GridStore);
  const confirmationService = inject(ConfirmationDialogService);

  if (gridStore.layout().length === 0 || !gridStore.gridHasChanges()) {
    return true;
  }

  const result = await confirmationService.confirmAtlasOverwritePromise(
    'Ungespeicherte Änderungen',
    'Ihre aktuelle Ansicht enthält ungespeicherte Änderungen. Möchten Sie diese verwerfen und fortfahren?'
  );

  if (result) {
    gridStore.resetGridHasChanges();
  }
  console.log('result', result);

  return result;
};
